import { useEffect, useRef, useState } from 'react';

/**
 * 用于跟踪是否离开过指定页面，并在返回时跳过动画
 * @param currentPage 当前页面
 * @param targetPage 目标页面,离开后返回需要跳过动画的页面
 */
export function useSkipAnimation(currentPage: string | number, targetPage: string | number = 'products') {
  const hasLeftTarget = useRef(false);
  const [skipAnimation, setSkipAnimation] = useState(false);

  useEffect(() => {
    if (currentPage !== targetPage) {
      hasLeftTarget.current = true;
    } else if (hasLeftTarget.current) {
      setSkipAnimation(true);
    }
  }, [currentPage, targetPage]);

  return skipAnimation;
}